const bestDate = (dateMissing, dateOfDeath, dateFound) => {
  // Missing, then found
  if (dateMissing != null && dateOfDeath != null) {
    return dateOfDeath;
  }
  // Missing, but not missing and found
  if (dateMissing != null) {
    return dateMissing;
  }
  // Only death
  if (dateOfDeath != null) {
    return dateOfDeath;
  }
  // Only fount
  if (dateFound != null) {
    return dateFound;
  }
  return "";
};

export default bestDate;
